var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#EEFFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 30.5C13.95 30.5 13.4793 30.3043 13.088 29.913C12.696 29.521 12.5 29.05 12.5 28.5V16.5C12.5 15.95 12.696 15.4793 13.088 15.088C13.4793 14.696 13.95 14.5 14.5 14.5H30.5C31.05 14.5 31.521 14.696 31.913 15.088C32.3043 15.4793 32.5 15.95 32.5 16.5V28.5C32.5 29.05 32.3043 29.521 31.913 29.913C31.521 30.3043 31.05 30.5 30.5 30.5H14.5ZM30.5 18.5L23.025 23.175C22.9417 23.225 22.854 23.2623 22.762 23.287C22.6707 23.3123 22.5833 23.325 22.5 23.325C22.4167 23.325 22.3293 23.3123 22.238 23.287C22.146 23.2623 22.0583 23.225 21.975 23.175L14.5 18.5V28.5H30.5V18.5ZM22.5 21.5L30.5 16.5H14.5L22.5 21.5ZM14.5 18.5V18.75V17.275V17.3V16.5V17.3V17.287V18.75V18.5V28.5V18.5Z",
    fill: "#0FAA8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6b5da6470f34f2c999b70e195d627db8.svg";
export { ForwardRef as ReactComponent };